import {useAppSelector} from 'store';
import {getDaysDifference} from 'utils/Helper';

import {DISCOUNT_VIEW_STATUS_LABELS} from '../../constants';
import {formatDiscountViewDate} from '../../utils';

const DiscountViewInfo: React.FC = () => {
  const {campaignCycle} = useAppSelector((state) => state.promotionCenter);
  const rows = [
    {
      title: 'وضعیت',
      value: campaignCycle?.state ? DISCOUNT_VIEW_STATUS_LABELS[campaignCycle.state] : ''
    },
    {title: 'تاریخ شروع', value: formatDiscountViewDate(campaignCycle?.start_date)},
    {title: 'تاریخ پایان', value: formatDiscountViewDate(campaignCycle?.end_date)},
    {
      title: 'مدت زمان تخفیف',
      value: `${getDaysDifference(campaignCycle?.start_date ?? '', campaignCycle?.end_date ?? '')} روز`
    }
  ];

  return (
    <section className="flex flex-col bg-white px-4 py-0.5">
      {rows.map((row, index) => (
        <div
          key={row.title}
          className={`flex h-11 items-center justify-between ${index < rows.length - 1 ? 'border-b border-gray-03' : ''}`}
        >
          <span className="text-body-sm-emphasis text-neutral-fg">{row.title}</span>
          <span className="text-body-sm text-neutral-fg">{row.value}</span>
        </div>
      ))}
    </section>
  );
};

export default DiscountViewInfo;
